import type { ReactNode } from 'react'

interface MarqueeProps {
  children: ReactNode
  duration?: number
  reverse?: boolean
}

export function Marquee({ children, duration = 60, reverse = false }: MarqueeProps) {
  return (
    <div
      className="marquee overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_8%,#000_92%,transparent)]"
      aria-hidden
    >
      <div
        className="marquee-track"
        style={{ animationDuration: `${duration}s`, animationDirection: reverse ? 'reverse' : 'normal' }}
      >
        <div className="flex shrink-0 items-center">{children}</div>
        <div className="flex shrink-0 items-center">{children}</div>
      </div>
    </div>
  )
}
